import { render, staticRenderFns } from "./OtherChooserModal.vue?vue&type=template&id=abb8bab8&scoped=true"
import script from "./OtherChooserModal.vue?vue&type=script&lang=js"
export * from "./OtherChooserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb8bab8",
  null
  
)

export default component.exports